const accessToken = '184a2d36cbb394967fe756e2fc1f415b'

import { Upload } from 'tus-js-client'

export async function getVimeoAccessToken() {

}

export async function getVimeoUploadLink(file: File, contentID: string, dealID?: string) {

  // const accessToken = getVimeoAccessToken();
  if (!accessToken) {
    throw new Error('No access token found');
  }
  const res = await fetch('https://api.vimeo.com/me/videos', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'Accept': 'application/vnd.vimeo.*+json;version=3.4'
    },
    body: JSON.stringify({
      upload: {
        approach: 'tus',
        size: file.size
      },
      name: contentID || dealID,
      "privacy": {
        "view": "unlisted",
        "download": false,
      },
      "content_rating": ["safe"],
    })
  });

  const json = await res.json();

  if (json.error) {
    throw new Error(json.error);
  }

  if (json.upload?.upload_link) {
    return {
      uploadLink: json.upload.upload_link,
      vimeoID: json.uri.split('/videos/')[1]
    }
  } else {
    throw new Error('No upload link found');
  }
}

export function uploadToVimeo(
  file: any,
  uploadLink: string,
  updateProgress: (progress: number) => void,
  onComplete: () => void
) {
  if (!accessToken) {
    throw new Error('No access token found');
  }

  const upload = new Upload(file, {
    uploadUrl: uploadLink,
    onError: function(error) {
      console.error('Failed because: ' + error)
      alert('Upload failed')
    },
    onProgress: function(bytesUploaded, bytesTotal) {
      const percentage = (bytesUploaded / bytesTotal * 100)
      updateProgress(percentage);
    },
    onSuccess: function() {
      updateProgress(100);
      setTimeout(() => {
        onComplete();
      }, 1000)
    }
  })

  upload.start()
  /*
  if (uploadLink) {
    const uploadRes = await fetch(uploadLink, { // run async
      method: 'PATCH',
      headers: {
        'Tus-Resumable': '1.0.0',
        'Upload-Offset': 0,
        'Content-Type': 'application/offset+octet-stream',
      },
      body: file
    });
    if (uploadRes.ok) {
      // return uploadJson;
    } else {
      console.error('Upload failed', uploadRes)
    }
    return uploadRes;
  }
  */

}

export async function checkProgress(uploadLink: string) {
  const res = await fetch(uploadLink, {
    method: 'HEAD',
    headers: {
      'Tus-Resumable': '1.0.0',
      'Accept': 'application/vnd.vimeo.*+json;version=3.4'
    }
  });
  const offset = res.headers.get('Upload-Offset');
  const length = res.headers.get('Upload-Length');

  if (!offset || !length) {
    throw new Error('No offset or length found');
  }
  const progress = (Number(offset) / Number(length));

  return {
    progress,
    isDone: progress === 1
  }
}

export async function getEmbedByVimeoID(ID: any) {
  // get private URL
  const urlRes = await fetch(`https://api.vimeo.com/videos/${ID}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    }
  });
  if (!urlRes.ok) {
    throw new Error('Failed to get embed URL');
  }
  const urlJson = await urlRes.json();
  if (urlJson.error) {
    throw new Error(urlJson.error);
  }

  if (urlJson?.upload.status !== 'complete') {
    return {
      html: '',
      uploadComplete: false,
      transCodeComplete: false
    }
  } else if (urlJson?.transcode?.status !== 'complete') {
    return {
      html: '',
      uploadComplete: true,
      transCodeComplete: false
    };
  }

  const hash = urlJson?.player_embed_url?.split('?h=')[1];
  //   const embedHtml = urlJson?.embed?.html;
  const { width, height } = urlJson;
  const heightToWidthRatio = height / width;
  const finalEmbed = `
      <iframe src="https://player.vimeo.com/video/${ID}?h=${hash}&title=false&byline=false&portrait=false&autoplay=false" width="400" height="${400 * heightToWidthRatio}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    `
  return { html: finalEmbed, uploadComplete: true, transcodeComplete: true, transCodeComplete: true };

}


export async function deleteVimeoVideo(ID: any) {
  const res = await fetch(`https://api.vimeo.com/videos/${ID}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    }
  });
  if (res.status === 204) {
    return true;
  } else {
    return false;
  }
}
